module.exports = __webpack_public_path__ + "static/img/Group 135.2c7eb0c5.png";